module.exports = __webpack_public_path__ + "img/3.ed069580.jpg";